export default {
  /*
   * index() lista las rutas
   */
  index(params) {
    return Vue.http.get('topology/routes', {params}).then(response => response.data)
  },
  /*
   * favorites() lista las rutas favoritas del usuario
   */
  favorites(params) {
    return Vue.http.get(
      'topology/routes/client_favorites', params
    ).then(response => response.data)
  },

  getRoute(id, params = {}) {
    return Vue.http.get(`topology/routes/${id}`, {params}).then(response => response.data)
  },
}
